const baseApi = 'https://api-meet.tatamd.com'
export default baseApi;